const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/sensor/sensor_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.sensor.powerDevice.title',
    secondaryTx: 'categories.sensor.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.sensor.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/sensor/sensor_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.sensor.confirmPairingMode.title',
    secondaryTx: 'categories.sensor.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.sensor.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.sensor.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/sensor/reset_sensor_step_1.png'),
          primaryTx: 'categories.sensor.resetDevice.step1.title',
          secondaryTx: 'categories.sensor.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/sensor/reset_sensor_step_2.png'),
          primaryTx: 'categories.sensor.resetDevice.step2.title',
          secondaryTx: 'categories.sensor.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/sensor/reset_sensor_step_3.gif'),
          primaryTx: 'categories.sensor.resetDevice.step3.title',
          secondaryTx: 'categories.sensor.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
